import Vue from 'vue'
import VueRouter from 'vue-router'
import BillingDetailsPage from '@/views/BillingDetailsPage'
import CustomersPage from '@/views/CustomersPage'
import CustomerSummary from '@/views/CustomerSummaryPage'
import DashboardPage from '@/views/DashboardPage'
import LoginPage from '@/views/LoginPage'
import ServicesPage from '@/views/ServicesPage'
import SitesPage from '@/views/SitesPage'
import TasksPage from '@/views/TasksPage'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'dashboard',
    component: DashboardPage
  },
  {
    path: '/customer',
    name: 'customer',
    component: CustomersPage
  },
  {
    path: '/billing/details/:id',
    name: 'billing-details',
    component: BillingDetailsPage,
    props: true
  },
  {
    path: '/scheduledservice/search/:siteId?/:siteDescription?',
    name: 'scheduledservice-search',
    component: ServicesPage,
    props: true
  },
  {
    path: '/scheduledtask/search/:customerId?/:customerName?',
    name: 'scheduledtask-search',
    component: TasksPage,
    props: true
  },
  {
    path: '/customer/summary/:id/:siteId?',
    name: 'customer-summary',
    component: CustomerSummary,
    props: true
  },
  {
    path: '/login/:defaultOfficeCode?',
    name: 'login',
    component: LoginPage,
    props: true
  },
  {
    path: '/site',
    name: 'site',
    component: SitesPage
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
